import React from 'react';

const ScheduleLectures = () => {
  return (
    <div className="schedule-lectures">
      <h1>Schedule Lectures</h1>
      <p>Bulk schedule multiple lectures</p>
    </div>
  );
};

export default ScheduleLectures;
